module.exports = __webpack_public_path__ + "i18n/tr.f5043641ad0b9d9dcc2655651e87447e.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/tr.json
// module id = 1315
// module chunks = 59